import { Link } from "react-router-dom";
import { Mail, MapPin, ShieldCheck } from "lucide-react";
import { SITE, NAV_LINKS } from "@/constants/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F1E36] text-slate-200 mt-24"
    >
      <div className="container-narrow py-16 grid gap-12 md:grid-cols-3">
        <div>
          <Link to="/" className="inline-flex items-center gap-3" data-testid="footer-logo">
            <img
              src={SITE.logoUrl}
              alt="Kernected Disability Support Services logo"
              className="h-14 w-auto bg-white rounded-lg p-2"
            />
          </Link>
          <p className="mt-5 text-[15px] leading-relaxed text-slate-300 max-w-sm">
            Brisbane-based NDIS Support Coordination, supporting participants
            and families across Queensland and Australia. We help you put your
            plan into action with confidence.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 text-sm text-slate-300">
            <ShieldCheck className="h-4 w-4 text-[#7AB4DF]" aria-hidden="true" />
            <span>Aligned with NDIS Practice Standards</span>
          </div>
        </div>

        <div>
          <h3 className="font-display text-base font-semibold tracking-wide uppercase text-white">
            Explore
          </h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-base font-semibold tracking-wide uppercase text-white">
            Get in touch
          </h3>
          <ul className="mt-5 space-y-4 text-[15px]">
            <li className="flex items-start gap-3">
              <Mail className="h-5 w-5 mt-0.5 text-[#7AB4DF]" aria-hidden="true" />
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email-link"
                className="break-all text-slate-200 hover:text-white"
              >
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-5 w-5 mt-0.5 text-[#7AB4DF]" aria-hidden="true" />
              <span className="text-slate-300">Brisbane · serving Queensland and Australia-wide</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-narrow py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <p>© {new Date().getFullYear()} {SITE.shortName}. All rights reserved.</p>
          <p className="text-slate-400">
            We acknowledge the Traditional Owners of the lands on which we work and pay our respects to Elders past and present.
          </p>
        </div>
      </div>
    </footer>
  );
};
